import { LoaderFunctionArgs, useLoaderData, useOutletContext } from "react-router";
import { createProfilesSharesPageURL } from "#lib/urls";
import { parseOffset } from "#lib/pagination";
import { fetchProfileShares } from "#api/shares";
import { PageSkeleton } from "#components/pages";
import { Paginator } from "#components/pagination";
import { CardList, ShareCard } from "#components/cards";
import { IShare } from "#entities/files";
import { OutletContext } from "./creators/creator-page";

interface IProps {
  shares: IShare[];
  total: number;
  offset?: number;
}

export function ProfileSharesPage() {
  const { shares, total, offset } = useLoaderData() as IProps;
  const { creator } = useOutletContext() as OutletContext;
  const title = "Filehaus";
  const heading = "Filehaus";

  return (
    <PageSkeleton name="all-dms" title={title} heading={heading}>
      <div id="paginator-top" className="paginator">
        <Paginator
          count={total}
          offset={offset}
          constructURL={(offset) =>
            String(createProfilesSharesPageURL(creator.service, creator.id, offset))
          }
        />
      </div>

      <CardList layout={"phone"}>
        {!total ? (
          <div className="no-results">
            <h2 className="site-section__subheading">
              Nobody here but us chickens!
            </h2>
            <p className="subtitle">There are no uploads.</p>
          </div>
        ) : (
          shares.map((share) => <ShareCard key={share.id} share={share} />)
        )}
      </CardList>

      <div className="paginator" id="paginator-bottom">
        <Paginator
          count={total}
          offset={offset}
          constructURL={(offset) =>
            String(createProfilesSharesPageURL(creator.service, creator.id, offset))
          }
        />
      </div>
    </PageSkeleton>
  );
}

export async function loader({
  params,
  request,
}: LoaderFunctionArgs): Promise<IProps> {
  const searchParams = new URL(request.url).searchParams;
  const service = params.service!.trim();
  const creatorId = params.creatorId!.trim();

  const inputOffset = searchParams.get("o")?.trim();
  const offset = inputOffset ? parseOffset(inputOffset) : 0;
  const { shares, total } = await fetchProfileShares(service, creatorId, offset);

  return {
    shares,
    total,
    offset,
  };
}
